import { routeConfig, stripLocalePrefix } from "../i18n/config";

const slugsFor = (key: keyof typeof routeConfig) => Object.values(routeConfig[key]);

const purchaseFlowSlugs = new Set([
    ...slugsFor("ostoskori"),
    ...slugsFor("luo_tili"),
    ...slugsFor("kirjaudu"),
    ...slugsFor("toimitus"),
    ...slugsFor("maksutapa"),
    ...slugsFor("tee_tilaus"),
]);

const buyCategorySlugs = new Set(slugsFor("osta"));

export const isPurchaseFlowPath = (pathname: string): boolean => {
    const path = stripLocalePrefix(pathname);
    const segments = path.split("/").filter(Boolean);
    const firstSegment = segments[0] ?? "";

    // Buy landing (/osta, /buy, /kop) is not checkout-locked.
    // Category route (/osta/:cat etc.) starts the purchase flow.
    if (buyCategorySlugs.has(firstSegment)) {
        return segments.length >= 2;
    }

    return purchaseFlowSlugs.has(firstSegment);
};
